  import { Component, OnInit, OnDestroy } from '@angular/core';
  import { NgForm } from '@angular/forms';
  import {  AuthService } from '../auth.service';
  import {  CommonService } from '../../services/common.service';
  import { Response , Request} from '@angular/http';
  import { Router } from '@angular/router';
  import {Users } from '../../classes/users';
  import { FormBuilder, Validators, FormGroup, ValidatorFn, AbstractControl, FormControl } from '@angular/forms';
  
  import { MatSnackBar } from '@angular/material';
import { DoctorService } from '../../services/doctor.service';
import { Roleid } from '../../classes/roleid.interface';
  @Component({
    selector: 'app-doctorlogin',
    templateUrl: './doctorlogin.component.html',
    styleUrls: ['./doctorlogin.component.css']
  })
  export class DoctorloginComponent implements OnInit {
    timer: any;
    ctimer = 5;
    userStatus: number;
    loading = false;
        error = '';
        loginform: any;
        redirecrcheckflag: number;
        roleid: Roleid[];
        flag: any;
        id: any;
        msg: string;
        action: any;
  constructor( private router: Router, private authService: AuthService, public form: FormBuilder,
      private commonservice: CommonService, private doctorservice: DoctorService, private snackBar: MatSnackBar) {
        const udata = this.commonservice.getUserDataLocally();
        this.loginform = this.form.group({
          'email': new FormControl("",[Validators.required,
          Validators.pattern(/^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i)]),
          'password': new FormControl("",[Validators.required]),
        });
      }

      ngOnInit() {
        this.userStatus = this.commonservice.checkUserStatus();
        if (this.userStatus === 1) {
         this.timer = setInterval(() => this.redirectAutomaticToDashboard(), 1000);
        }
        }
        redirectAutomaticToDashboard() {
            this.ctimer = this.ctimer - 1 ;
            if (this.ctimer === 0) {
              clearInterval(this.timer);
              this.router.navigate(['/doctor'])
            }
        }
        onSubmit() {
          this.loading = true;
                this.authService.serviceproviderLogin(this.loginform.email, this.loginform.password)
                .subscribe(result => {
                  if (result === true) {
                      // login successful
                      this.authService.setRoleId(3);
                      this.loading = false;
                      this.commonservice.loginsuccess.next(1);
                       this.router.navigate(['/doctor/home']);
                     }
              },
              (err) => {
                this.loading = false;
                if (err.status === 501) {
                  this.msg = 'This is not a valid serviceprovider credential';
                  this.openSnackBar();
                }else {
                  this.msg = 'Username or password is incorrect';
                  this.openSnackBar();
                }
            });
        }
      openSnackBar() {
          this.snackBar.open(this.msg , this.action, {
            duration: 4000,
          });
        }

 }
